// Published material ABOUT Ravi Teja Alchuri (independent media coverage and features).
export const pressData = [
    {
        id: 1,
        outlet: 'AI Time Journal',
        kind: 'Feature Interview',
        title: 'Engineering Trustworthy AI for Production-Scale Fleet Systems',
        excerpt: 'A feature interview on deploying AI reliably across 100,000+ vehicles: why production AI depends on systems discipline, governance guardrails, and operational trust rather than model sophistication alone.',
        author: 'Interview by Martin Russo',
        date: 'March 12, 2026',
        url: 'https://aitimejournal.com/ravi-teja-alchuri-engineering-trustworthy-ai-for-production-scale-fleet-systems',
    },
    {
        id: 2,
        outlet: 'Outlook India',
        kind: 'Profile',
        title: 'Architecting at Scale: The Technology Leadership of Ravi Teja Alchuri',
        excerpt: 'A profile of a technology leader with over a decade building systems in high-stakes telematics and compliance-heavy platforms, tracing the path from core engineering to platform leadership grounded in reliability, scale, and practical AI.',
        author: 'By Manish Saini',
        date: 'March 27, 2026',
        url: 'https://www.outlookindia.com/hub4business/architecting-at-scale-the-technology-leadership-of-ravi-teja-alchuri',
    },
];
